import axios from "axios";

//export const API_BASE_IP="127.0.0.1" // For development
export const API_BASE_IP="betterbaduk.com" // For production


const apiClient = axios.create({
  baseURL: `https://${API_BASE_IP}/api`, 
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refresh_token");
        if (!refreshToken) {
          throw new Error("No refresh token available.");
        }

        const { data } = await axios.post(`https://${API_BASE_IP}/api/token/refresh/`, {
          refresh: refreshToken,
        });

        console.log('Storing new access token:',data.access)
        console.log('Storing new refresh token:',data.refresh)

        // Save new tokens
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);

        // Update Authorization headers
        apiClient.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.access}`;
        originalRequest.headers["Authorization"] = `Bearer ${data.access}`;

        return apiClient(originalRequest); // Retry the original request
      } catch (refreshError) {
        console.error("Token refresh failed", refreshError);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        // window.location.href = "/login"; // Redirect to login
      }
    }

    return Promise.reject(error);
  }
);

export const fetchSGFs = async (setSgfs) => {
  try {
    const response = await apiClient.get("/sgf/", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch SGFs");
    }

    const data = await response.json();

    setSgfs(data);

  } catch (err) {
    console.error(err);
    throw err;
  }
};

/**
 * Update an SGF file on the backend.
 * @param {string} gameId - The unique game ID of the SGF file.
 * @param {string} newSgfContent - The new SGF content to update.
 * @returns {Promise<object>} - Updated SGF data or error response.
 */
export const updateSGF = async (gameId, newSgfContent) => {
  try {
    const response = await apiClient.patch(`/sgf/${gameId}/`, {
      sgf_content: newSgfContent,
    });

    console.log("SGF updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to update SGF:", error.response?.data || error.message);
    throw error;
  }
};

export default apiClient;